import { api } from './api';
import { useWorkspaceStore } from '../store/workspace';

/**
 * Swaps the session cookie, then reloads so every store and query cache starts fresh for the
 * new identity. The persisted workspace selection belongs to the previous identity, so drop it,
 * unless the caller names the workspace to land in (kept only if the new identity belongs to it).
 */
async function switchIdentity(request: () => Promise<unknown>, landingPath: string, workspaceId: string | null = null) {
  await request();
  useWorkspaceStore.setState({ activeWorkspaceId: workspaceId, workspaces: [] });
  window.location.assign(landingPath);
}

export function startImpersonation(
  userId: string,
  { landingPath = '/dashboard', workspaceId = null }: { landingPath?: string; workspaceId?: string | null } = {},
) {
  return switchIdentity(() => api.post(`/system/users/${userId}/impersonate`), landingPath, workspaceId);
}

export function stopImpersonation() {
  return switchIdentity(() => api.post('/system/impersonation/stop'), '/system/users');
}
